// Only the server's comparable series is suitable for a price chart.
export function comparableHistory(history = []) {
  const valid = history.filter((row) =>
    row.normalization_status === "ok"
    && typeof row.normalized_price_ht === "number"
    && Number.isFinite(row.normalized_price_ht)
    && row.normalized_price_ht > 0
    && ["€/u", "€/kg", "€/L"].includes(row.normalized_unit)
    && Number.isFinite(Date.parse(row.date))
  ).sort((a, b) => Date.parse(a.date) - Date.parse(b.date));
  const unit = valid.at(-1)?.normalized_unit;
  return valid.filter((row) => row.normalized_unit === unit).map((row) => ({
    ...row,
    _norm: row.normalized_price_ht,
    _unit: row.normalized_unit === "€/u" ? "€/pièce" : row.normalized_unit,
  }));
}
